import { EmptyState, NoDataIcon } from '@lmc/ui-kit'
import { NAMESPACE } from 'locale'
import { useTranslation } from 'react-i18next'
import { riskAssessmentReportConstants as translations } from 'locale/riskAssessmentReports'

const NoDataEmptyState = () => {
  const { t } = useTranslation(NAMESPACE.RISK_ASSESSMENT_REPORT)
  return (
    <EmptyState
      title={t(translations.EMPTY_STATE_NO_DATA)}
      description={t(translations.EMPTY_STATE_NO_DATA_DESCRIPTION)}
      icon={<NoDataIcon />}
    />
  )
}

export default NoDataEmptyState
